import { render, staticRenderFns } from "./ocrFieldCheckConfigDialog.vue?vue&type=template&id=5cb42fbe&"
import script from "./ocrFieldCheckConfigDialog.vue?vue&type=script&lang=js&"
export * from "./ocrFieldCheckConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb42fbe')) {
      api.createRecord('5cb42fbe', component.options)
    } else {
      api.reload('5cb42fbe', component.options)
    }
    module.hot.accept("./ocrFieldCheckConfigDialog.vue?vue&type=template&id=5cb42fbe&", function () {
      api.rerender('5cb42fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/ocrFieldCheckConfigDialog.vue"
export default component.exports